import { useEffect, useState } from 'react';
import './App.css';


function App() {
  const [advice, setAdvice] = useState('');
  
  const getAdvice = async ()=>{
  const response = await fetch (`https://www.boredapi.com/api/activity/`);
  const data = await response.json();
    setAdvice(data.activity)
    };
    
    useEffect(() =>{
      getAdvice()
    }, [])

  return (<div className='container'>
    <div>
      <h1>No time to be bored!</h1>
    </div>
    <h3>Click on the button and find out what you can do now</h3>
    <div className='advice'>
      <h2>{advice}</h2>
    </div>
    <div>
      <button onClick={getAdvice}>New advice</button>
    </div>
    </div>);
}

export default App;
